/* cart-page.js
 * Keeps the premium cart page in sync with cart updates.
 *
 * Dawn's cart.js re-renders `.js-contents` inside `#main-cart-items`, but the
 * header count and some line totals can still lag. We listen to cartUpdate and
 * patch counts, line quantities, line prices, and footer totals from the cart
 * JSON returned by Shopify.
 */
(function () {
  function init() {
    if (typeof subscribe !== 'function') return;
    if (typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.cartUpdate) return;

    const cartRoot = document.querySelector('cart-items.cart-page--premium');
    const cartFooter = document.getElementById('main-cart-footer');
    const headerAside = document.querySelector('.cart-page--premium .cart-page__header-aside');
    if (!headerAside && !cartFooter && !cartRoot) return;

    const moneyFormat = cartRoot?.dataset.moneyFormat || cartFooter?.dataset.moneyFormat;
    const moneyWithCurrencyFormat =
      cartRoot?.dataset.moneyWithCurrencyFormat || cartFooter?.dataset.moneyWithCurrencyFormat || moneyFormat;
    const numberEl = headerAside?.querySelector('.cart-page__count-number');
    const labelEl = headerAside?.querySelector('.cart-page__count-label');
    const loginNote = document.querySelector('.cart-page--premium .cart-page__login-note');

    function formatMoney(cents, useCurrency = false) {
      if (window.Shopify?.formatMoney && moneyFormat) {
        return window.Shopify.formatMoney(cents, useCurrency ? moneyWithCurrencyFormat : moneyFormat);
      }
      return `${(Number(cents) / 100).toFixed(2)}`;
    }

    function applyCount(rawCount) {
      const count = Number(rawCount);
      if (!Number.isFinite(count)) return;

      if (numberEl) {
        numberEl.textContent = count.toString().padStart(2, '0');
      }
      if (labelEl) {
        labelEl.textContent = count === 1 ? 'piece in your bag' : 'pieces in your bag';
      }

      if (count === 0) {
        if (headerAside) headerAside.style.display = 'none';
        if (loginNote) loginNote.style.display = 'none';
      } else {
        if (headerAside) headerAside.style.display = '';
        if (loginNote) loginNote.style.display = '';
      }
    }

    function applyTotals(cartData) {
      if (!cartData) return;
      const subtotalEl = document.querySelector('[data-cart-subtotal]');
      const totalEls = document.querySelectorAll('[data-cart-total]');

      if (subtotalEl && Number.isFinite(Number(cartData.items_subtotal_price))) {
        subtotalEl.textContent = formatMoney(cartData.items_subtotal_price);
      }

      if (totalEls.length && Number.isFinite(Number(cartData.total_price))) {
        totalEls.forEach((element) => {
          element.textContent = formatMoney(cartData.total_price, true);
        });
      }
    }

    function applyLineItems(cartData) {
      if (!cartData?.items?.length) return;

      cartData.items.forEach((item, index) => {
        const line = index + 1;
        const row = document.getElementById(`CartItem-${line}`);
        if (!row) return;

        const input = document.getElementById(`Quantity-${line}`);
        if (input) {
          const qty = String(item.quantity);
          input.value = qty;
          input.setAttribute('value', qty);
        }

        row.querySelectorAll('.cart-item__totals .cart-item__price-wrapper').forEach((wrapper) => {
          if (item.original_line_price !== item.final_line_price) {
            const oldPrice = wrapper.querySelector('.cart-item__old-price');
            const salePrice = wrapper.querySelector('.cart-item__discounted-prices .price--end');
            if (oldPrice) oldPrice.textContent = formatMoney(item.original_line_price);
            if (salePrice) salePrice.textContent = formatMoney(item.final_line_price);
          } else {
            const linePrice = wrapper.querySelector('.price--end');
            if (linePrice) linePrice.textContent = formatMoney(item.final_line_price);
          }
        });

        const detailsUnitPrice = row.querySelector('.cart-item__details > .product-option');
        if (item.original_price !== item.final_price) {
          const oldUnit = row.querySelector('.cart-item__details .cart-item__old-price.product-option');
          const finalUnit = row.querySelector('.cart-item__details .cart-item__final-price');
          if (oldUnit) oldUnit.textContent = formatMoney(item.original_price);
          if (finalUnit) finalUnit.textContent = formatMoney(item.final_price);
        } else if (detailsUnitPrice) {
          detailsUnitPrice.textContent = formatMoney(item.original_price);
        }
      });
    }

    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (!event || !event.cartData) return;
      applyCount(event.cartData.item_count);
      applyLineItems(event.cartData);
      applyTotals(event.cartData);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
